module.exports = __WEBPACK_EXTERNAL_MODULE_801__;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 801
// module chunks = 22